/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    CONSOLE_USERS_title: "Utilisateurs Console",
    CONSOLE_USERS_label: "utilisateur",
    CONSOLE_USERS_plural_label: "utilisateurs",
    CONSOLE_USERS_back: "Retour aux utilisateurs",

    CONSOLE_USERS_columnName: "Nom",
    CONSOLE_USERS_columnEmail: "Email",
    CONSOLE_USERS_columnPhone: "Téléphone",
    CONSOLE_USERS_columnRole: "Rôle",
    CONSOLE_USERS_columnState: "État",

    CONSOLE_USERS_invite: "Créer un utilisateur",
    CONSOLE_USERS_inviteTitle: "Créer un utilisateur",
    CONSOLE_USERS_confirmInvite: "Créer l'utilisateur",

    CONSOLE_USERS_fieldFirstName: "Prénom",
    CONSOLE_USERS_fieldFirstNamePlaceholder: "ex. Marie",
    CONSOLE_USERS_fieldLastName: "Nom",
    CONSOLE_USERS_fieldLastNamePlaceholder: "ex. Dupont",
    CONSOLE_USERS_fieldEmail: "Email",
    CONSOLE_USERS_fieldEmailPlaceholder: "marie.dupont@facilogi.com",
    CONSOLE_USERS_fieldPhone: "Téléphone",
    CONSOLE_USERS_fieldPhonePlaceholder: "06 12 34 56 78",
    CONSOLE_USERS_fieldPassword: "Mot de passe",
    CONSOLE_USERS_fieldPasswordPlaceholder: "Mot de passe de l'utilisateur",
    CONSOLE_USERS_passwordHint: "9 caractères min., avec majuscule, minuscule et chiffre. "
        + "Communiquez-le à l'utilisateur. Il configurera sa double authentification à la "
        + "première connexion.",
    CONSOLE_USERS_inviteEmailHint: "L'utilisateur recevra un email avec un lien pour activer son "
        + "compte et définir son mot de passe. Il configurera sa double authentification à la "
        + "première connexion.",
    CONSOLE_USERS_fieldRole: "Rôle",
    CONSOLE_USERS_rolePlaceholder: "Sélectionner un rôle",
    CONSOLE_USERS_noRole: "Aucun rôle",

    CONSOLE_USERS_filterState: "État",
    CONSOLE_USERS_filterStatePlaceholder: "Filtrer par état",
    CONSOLE_USERS_stateActive: "Actif",
    CONSOLE_USERS_statePending: "En attente",
    CONSOLE_USERS_stateDisabled: "Désactivé",

    CONSOLE_USERS_inviteSuccessTitle: "Invitation envoyée",
    CONSOLE_USERS_inviteSuccessMessage: "Un email d'activation a été envoyé à l'utilisateur.",

    CONSOLE_USERS_detailTitle: "Détail de l'utilisateur",
    CONSOLE_USERS_sectionInfo: "Informations",
    CONSOLE_USERS_sectionRole: "Rôle et privilèges",
    CONSOLE_USERS_pendingNotice: "Cet utilisateur n'a pas encore activé son compte.",

    CONSOLE_USERS_actionDisable: "Désactiver",
    CONSOLE_USERS_actionReactivate: "Réactiver",
    CONSOLE_USERS_actionReinvite: "Renvoyer l'invitation",
    CONSOLE_USERS_actionAssignRole: "Attribuer le rôle",
    CONSOLE_USERS_edited: "Informations mises à jour.",
    CONSOLE_USERS_formChanged: "Pas de changements | Vous avez modifié 1 champ d'utilisateur | " +
        "Vous avez modifié {count} champs d'utilisateur",

    CONSOLE_USERS_disableConfirm: "Êtes-vous certain de vouloir désactiver cet utilisateur ?" +
        " Il ne pourra plus se connecter à la Console.",
    CONSOLE_USERS_disabled: "Utilisateur désactivé.",
    CONSOLE_USERS_reactivated: "Utilisateur réactivé.",
    CONSOLE_USERS_reinvited: "Invitation renvoyée.",
    CONSOLE_USERS_roleAssigned: "Rôle attribué.",

    CONSOLE_USERS_accountDisabled: "Ce compte est désactivé.",
    CONSOLE_USERS_cannotDisableSuperAdmin: "Un Super Admin ne peut pas être désactivé.",
    CONSOLE_USERS_superAdminRoleLocked: "Le rôle d'un Super Admin ne peut pas être modifié.",
    CONSOLE_USERS_invalidInvitation: "Cette invitation est invalide ou a déjà été utilisée.",

    CONSOLE_USERS_splashScreenTitle: "Invitez votre premier utilisateur",
    CONSOLE_USERS_splashScreenDescription: "Les utilisateurs Console sont les membres de votre " +
        "équipe qui accèdent à la Console."
};
